import { Injectable, Component, ViewEncapsulation, Input, ViewChild, HostListener, NgModule } from '@angular/core';
import { KeyCodes } from '@ngx-lite/util';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxMenuService {
    constructor() {
        this.visible = new Subject();
    }
}
NgxMenuService.decorators = [
    { type: Injectable }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxMenuComponent {
    /**
     * @param {?} ngxMenuService
     */
    constructor(ngxMenuService) {
        this.ngxMenuService = ngxMenuService;
        this.hover = false;
        this.visible = false;
        this.offsetHeight = 0;
        this.offsetLeft = 0;
        this.subscription = this.ngxMenuService.visible.subscribe((/**
         * @param {?} v
         * @return {?}
         */
        v => (this.visible = v)));
    }
    /**
     * @param {?} event
     * @return {?}
     */
    toggle(event) {
        // todo:
        // - recalculate on resize
        // - trap focus in menu with arrow key navigation
        /** @type {?} */
        const button = event.currentTarget;
        /** @type {?} */
        const menuWidth = this.menu.nativeElement.offsetWidth;
        /** @type {?} */
        const buttonOffsetLeft = button.offsetLeft;
        /** @type {?} */
        const buttonWidth = button.offsetWidth;
        this.ngxMenuService.visible.next(false);
        this.visible = !this.visible;
        this.offsetHeight = button.offsetTop + button.offsetHeight;
        if (menuWidth + buttonOffsetLeft > window.innerWidth) {
            this.offsetLeft = buttonOffsetLeft - menuWidth + buttonWidth;
        }
        else {
            this.offsetLeft = buttonOffsetLeft;
        }
        event.stopPropagation();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    /**
     * @return {?}
     */
    outerClick() {
        this.visible = false;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    outerTab(event) {
        if ((event.keyCode === KeyCodes.Tab || event.keyCode === KeyCodes.Escape) &&
            this.visible === true) {
            this.visible = false;
        }
    }
}
NgxMenuComponent.decorators = [
    { type: Component, args: [{
                selector: 'ngx-menu',
                template: "<div role=\"menu\" class=\"ngx-menu\" [attr.aria-hidden]=\"!visible\" [style.visibility]=\"visible ? 'visible' : 'hidden'\" #menu\n  [style.top.px]=\"offsetHeight\" [style.left.px]=\"offsetLeft\">\n  <ng-content></ng-content>\n</div>",
                encapsulation: ViewEncapsulation.None,
                styles: ["*,::after,::before{box-sizing:border-box}.ngx-menu{display:inline-block;padding:8px 0;background:#fff;border:1px solid #dbdbdb;position:absolute;top:0;left:0;min-width:130px}.ngx-menu a,.ngx-menu button{cursor:pointer;display:block;background:0 0;border:0;width:100%;text-align:left;padding:12px;text-decoration:none;font-weight:400;color:#2d2d2d}.ngx-menu a:hover,.ngx-menu button:hover{background-color:#f2f2f2}"]
            }] }
];
/** @nocollapse */
NgxMenuComponent.ctorParameters = () => [
    { type: NgxMenuService }
];
NgxMenuComponent.propDecorators = {
    hover: [{ type: Input }],
    menu: [{ type: ViewChild, args: ['menu', { static: false },] }],
    outerClick: [{ type: HostListener, args: ['document:click',] }],
    outerTab: [{ type: HostListener, args: ['window:keyup', ['$event'],] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxMenusModule {
}
NgxMenusModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                declarations: [NgxMenuComponent],
                exports: [NgxMenuComponent],
                providers: [NgxMenuService]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxMenuComponent, NgxMenusModule, NgxMenuService as ɵa };
//# sourceMappingURL=ngx-lite-menus.js.map
